<template>
    <div>
        <nav class="navbar navbar-default  navbar-fixed-top" v-if="me">
            <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="#/" style="background-color: #d1d1d1">
                        <img style="height: 43px;" :src="logo">
                    </a>
                </div>
                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <div id="navbar" >
                        <ul v-if="!block" class="nav navbar-nav">

                            <menu-relatorios :me="me" />

                            <menu-financeiro :me="me"  v-if="me.admin || me.acesso_financeiro" />

                            <menu-monitoramento :me="me" v-if="me.admin || me.acesso_monitoramento"/>

                            <menu-cadastro :me="me" v-if="me.admin || me.acesso_cadastros" />

                            <li>
                                <a :href="urlNovoAdmin" target="_blank" rel="noopener noreferrer">
                                    <i class="fa fa-external-link"></i> NOVO ADMIN
                                </a>
                            </li>

                        </ul>
                        <ul class="nav navbar-nav navbar-right">

                            <!--
                            <menu-eventos v-if="! block && (me.admin || me.acesso_monitoramento)"/>
                            -->

                            <menu-drop-down-me :me="me" :block="block" />
                        </ul>
                    </div><!--/.nav-collapse -->
                </div>
            </div>
        </nav>
        <alerta-modal :id="id_alerta" @closed="add(null)"/>
    </div>

</template>
<script>
    import MenuEventos from './menus/MenuEventos.vue';
    import Vue from 'vue';
    import { Comandos } from "../class";
    import { SET_ALERTAS } from "../mutation-types";
    import AlertaModal from "../components/modals/AlertaModal";
    import { Login } from "../class/login";
    import {store} from '../store';
    import MenuFinanceiro from './menus/MenuFinanceiro.vue';
    import MenuRelatorios from './menus/MenuRelatorios.vue';
    import MenuCadastro from './menus/MenuCadastro.vue';
    import MenuMonitoramento from './menus/MenuMonitoramento.vue';
    import MenuDropDownMe from './menus/MenuDropDownMe.vue';
    export default {
        name: "MenuSuperior",
        components: {
            MenuDropDownMe,
            MenuMonitoramento,
            MenuCadastro,
            MenuRelatorios,
            MenuFinanceiro,
            MenuEventos,
            AlertaModal
        },
        props: {
            block: false
        },
        data () {
            return {
                id: null,
                me: null,
            }
        },
        computed: {
            id_alerta () {
                if (this.$store.state.idAlerta) {
                    $(AlertaModal.ID).modal('show');
                }
                return this.$store.state.idAlerta;
            },
            logo(){
                return Vue.http.options.root + "/logo?token="+ window.localStorage.getItem('token');
            },
            urlNovoAdmin () {
                const token = window.localStorage.getItem('token') || '';
                const usuario = window.localStorage.getItem('usuario') || '';
                if (!token || !usuario) {
                    return 'https://add-test.rastreamos.com.br/#/';
                }
                return 'https://add-test.rastreamos.com.br/#/login/token/'
                    + encodeURIComponent(token) + '/'
                    + encodeURIComponent(usuario);
            }
        },
        async beforeMount () {
            await this.loadMe();
        },
        methods: {
            async loadMe () {
                this.me = await Login.me();
            },
            add (id) {
                this.$store.commit(SET_ALERTAS, id);
            },
            async solicitarConfiguracoesTodos () {
                await Comandos.solicitarConfiguracaoTodos();
                toastr.success("Solicitado de todos com sucesso!");
            }
        },
    }
</script>

<style>
    .label,.glyphicon { margin-right:5px; }

    .mega-dropdown {
        position: static !important;
    }
    .mega-dropdown-menu {
        padding: 20px 0;
        width: 100%;
        box-shadow: none;
        -webkit-box-shadow: none;
    }
    .mega-dropdown-menu > li > ul {
        padding: 0;
        margin: 0;
    }
    .mega-dropdown-menu > li > ul > li {
        list-style: none;
    }
    .mega-dropdown-menu > li > ul > li > a {
        display: block;
        color: #222;
        padding: 3px 5px;
    }
    .mega-dropdown-menu > li ul > li > a:hover,
    .mega-dropdown-menu > li ul > li > a:focus {
        text-decoration: none;
    }
    .mega-dropdown-menu .dropdown-header {
        color: #ff3546;
        padding: 5px 60px 5px 5px;
        line-height: 30px;
    }

    @media (max-width:767px){
        .mega-dropdown-menu .dropdown-header {
            color: #ffffff;
            display: none;
            font-weight: bold;
        }
        .mega-dropdown-menu > li > ul > li > a {
            color: #fff;
            line-height: 25px;
            padding-left: 10px;
        }
    }

    .carousel-control {
        width: 30px;
        height: 30px;
        top: -35px;

    }
    .left.carousel-control {
        right: 30px;
        left: inherit;
    }
    .carousel-control .glyphicon-chevron-left,
    .carousel-control .glyphicon-chevron-right {
        background-color: #fff;
        line-height: 30px;
        text-shadow: none;
        color: #333;
        border: 1px solid #ddd;
    }
</style>
